// import React, { Component } from 'react';
import React from 'react';

const game = () => { 
    return <div>Default Game DIV</div>
};

export default game;
